import React from 'react'
import { WrappedFieldProps } from 'redux-form'

import { SignaturePadProps } from 'components/SignaturePad/SignaturePad'

import { FieldError, SignaturePad } from 'components'

type FormSignaturePadFullProps = SignaturePadProps & WrappedFieldProps & {
  signatureRef: any
}

const FormSignaturePad: React.FC<FormSignaturePadFullProps> = ({
  disabled,
  input: { onChange, value },
  meta: { error, submitFailed, valid },
  signatureRef,
  ...rest
}) => (
  <React.Fragment>
    <SignaturePad.Container disabled={disabled} invalid={submitFailed && !valid}>
      <SignaturePad
        {...rest}
        error={submitFailed && error}
        ref={signatureRef}
        value={value?.value ? value.value : value}
        onChange={onChange}
      />
    </SignaturePad.Container>
    <FieldError error={submitFailed && error} />
  </React.Fragment>
)

export default FormSignaturePad
